<template>
   <!-- à part des data dans jobs, créer un tableau catégories. -->
     <!-- générer une liste des catégories -> pour chaque catégorie créer un dropdown a partir du tableau results et afficher uniquement les métiers qui on la catégorie correspondante  -->
  <div class="jobsList">
      <div v-for="(category, index) in sortedCategories" :key="index" class="cat-results" >
        
        <h4 @click="toggleDropdown(index)">{{  decodeHtml(category) }} <span>({{ filteredResultsByCategory(category).length }})</span></h4>

        <ul v-if="isDropdownOpen(index)" class="dropdown-menu" data-simplebar>
          <li v-for="result in filteredResultsByCategory(category)" :key="result.jobIndex"
          @click="updateIndex(result.jobIndex)"
          :class="['job', (activeLink===result.jobIndex ? 'active' : '') ]"
          :style="{color:percentageColor(result.percentage)}"
          >
            <!-- <div class="count">{{ index+1 }}. </div> -->
            <span>{{ selectedCountry === 'fr' && jobs[result.jobIndex].metier_fr ? jobs[result.jobIndex].metier_fr : jobs[result.jobIndex].metier }}</span>
            <!--<span class="percentage">{{ result.percentage }}%</span>-->
          </li>
        </ul>

      </div>
  </div>
</template>

<style lang="scss">

  .jobsList {
    margin-top: 40px;
    margin-bottom: 50px;
    width: 100%;
    margin-left: auto;
    //height: calc(75vh - 80px);
      // padding-right: 40px;
    // overflow-y: scroll;

    @media all and (max-width: 768px) {
      text-align: left;
    }

    .cat-results {
      margin-bottom:20px;
      h4 {
        cursor: pointer;
        //§font-weight: 100;
        span {
          font-family: 'Titillium Web', sans-serif;
        }
      }
      ol,
      ul {
        height: auto;
        max-height: 210px;
        list-style: none;
        margin: 0;
        padding:0 0 0px 0;
        padding-right: 20px;
        margin-top: 15px;

        @media all and (min-width: 768px) {
          max-height: inherit;
        }

        li.job {
          cursor: pointer;
          font-size: 16px;
          margin-left: 0px;
          line-height: 1.2;
          margin-bottom: 8px;
          position: relative;

          .percentage {
            &:before {
              content: ' - ';
            }
          }

          @media all and (max-width: 540px) {
            font-size: 15px;
            display: flex;

            .percentage {
              margin-left: auto;
              &:before {
                content: '';
              }
            }
          }

          .count{
            position:relative;
            display: inline-block;
            padding-right: 5px;
          }
        }

        .clicked {
          text-decoration: underline;
          @media all and (max-width: 540px) {
            text-decoration: inherit;
          }
        }
      }
    }
  }
  .active {
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media all and (max-width: 540px) {
      display: inherit;
    }

    @media all and (max-width: 768px) {
      align-items: left;
      justify-content: flex-start;
    }

    &::before {
      content: '';
      display: block;
      margin-left: -8px;
      margin-right: 10px;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 8px solid #000;

      @media all and (max-width: 540px) {
        display: none;
      }
    }
  }

</style>

<script>
export default {
  name: 'resultsJobsList',

  props: {
    initActiveJob: {
      type: Number,
      default: function() {
        // Le premier résultat est automatiquement le meilleur
        return this.$store.state.results.length > 0 ? this.$store.state.results[0].jobIndex : 0
      }
    }
  },

  data () {
    return {
      // results: [],
      activeLink: this.initActiveJob,
      color: '#000',
      prevIndex: 0,
      openDropdownIndex: null
    }
  },
  methods: {
    updateIndex: function (value) {
      this.$emit('updateIndex', value)
      this.activeLink = value
    },
    onclick (value) {
      this.updateIndex(value)
      this.prevIndex = value
    },
    mouseover (index) {
      this.updateIndex(index)
    },
    mouseleave () {
      this.updateIndex(this.prevIndex)
    },
    decodeHtml(html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },
    percentageColor ($percentage) {
      let color = 'black'
      if ($percentage >= 95) {
        color = 'ForestGreen'
      } else if ($percentage >= 85 && $percentage < 95) {
        color = 'YellowGreen'
      } else if ($percentage >= 75 && $percentage < 85) {
        color = 'GoldenRod'
      } else if ($percentage >= 0 && $percentage < 75) {
        color = 'Tomato'
      }
      return color
    },
  

    filteredResultsByCategory(category) {
      let filteredResults = this.results.filter(result => {
        const job = this.jobs[result.jobIndex]
        
        // Vérifier si le métier appartient à la catégorie
        const belongsToCategory = result.jobCategory === category
        
        // Pour la Suisse : toujours afficher les métiers (pas de condition sur cursus_ch)
        if (this.selectedCountry === 'ch') {
          return belongsToCategory
        }
        
        // Pour les autres pays (comme la France) : vérifier que le cursus existe
        const cursusField = `cursus_${this.selectedCountry}`
        const hasCursusForCountry = job[cursusField] && job[cursusField].trim() !== ''
        
        return belongsToCategory && hasCursusForCountry
      })

      // Appliquer le filtrage des doublons si nécessaire
      return this.removeDuplicatesByMetierName(filteredResults)
    },

    // Nouvelle méthode pour supprimer les doublons
    removeDuplicatesByMetierName(results) {
      if (this.selectedCountry !== 'fr') {
        return results // Pas de filtrage pour les autres pays
      }

      const seenMetiers = new Set()
      const uniqueResults = []

      results.forEach(result => {
        const job = this.jobs[result.jobIndex]
        const metierName = job.metier_fr || job.metier
        
        if (!seenMetiers.has(metierName)) {
          seenMetiers.add(metierName)
          uniqueResults.push(result)
          console.log(`Métier gardé: ${metierName} (index: ${result.jobIndex})`)
        } else {
          console.log(`Métier masqué (doublon): ${metierName} (index: ${result.jobIndex})`)
        }
      })

      return uniqueResults
    },
    sortCategories(categories) {
      return categories.sort((a, b) => {
        if (a === 'Autres métiers') return 1
        if (b === 'Autres métiers') return -1
        return a.localeCompare(b)
      })
    },
    toggleDropdown(index) {
      console.log('toggleDropdown', index)
      if (this.openDropdownIndex === index) {
        this.openDropdownIndex = null
      } else {
        this.openDropdownIndex = index
      }
    },
    isDropdownOpen(index) {
      return this.openDropdownIndex === index
    },
    findActiveDropdown() {
      for (let i = 0; i < this.categories.length; i++) {
        const category = this.categories[i]
        const results = this.filteredResultsByCategory(category)
        if (results.some(result => result.jobIndex === this.activeLink)) {
          this.openDropdownIndex = i
          break
        }
      }
    }
  },
  computed: {
    jobs () {
      return this.$store.state.jobs
    },
    userResponses () {
      return this.$store.state.userResponses
    },
    results () {
      return this.$store.state.results
    },
    categories () {
     console.log(this.jobs)
      const categoriesSet = new Set()
      this.jobs.forEach(job => {
        if (job.category_name
        ) {
          categoriesSet.add(job.category_name
          )
        }
      })
      return Array.from(categoriesSet)
    },
    sortedCategories() {
      return this.sortCategories(this.categories)
    },
    selectedCountry () {
      return this.$store.state.selectedCountry
    },
    
  },
  mounted: function () {
    //this.findActiveDropdown()
  }
}
</script>
